export default __webpack_public_path__ + "static/media/NOT_ELIGIBLE_BLUE.332401ee.svg";